import CompanyMemberDecorator from "./CompanyMemberDecorator";
import AdminUserDecorator from "./AdminUserDecorator";

export default class CompanyMemberFullDecorator extends CompanyMemberDecorator {
  static build() {
    return new CompanyMemberFullDecorator({
      _new: true,
      id: null,
      admin_user: {
        id: null,
        email: null,
        full_name: null,
      },
      role: "company_admin",
    });
  }

  constructor(data) {
    super({
      ...data,
      admin_user: data.admin_user && new AdminUserDecorator(data.admin_user),
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CompanyMemberFullDecorator.js